import React from "react";
import { Link } from "react-router-dom";
import colors from "../../utils/colors";
import {
  navLogo,
  instagram,
  linkedin,
  email,
  whatsapp,
  lineFooter,
} from "../../assets";

const AboutFooter = () => {
  return (
    <footer style={{ background: colors.dark }}>
      {/* Top Section */}
      <div className="flex flex-col gap-12 px-6 py-10 md:flex-row md:gap-20 md:px-20 md:py-16">
        {/* Logo + Description + Icons */}
        <div className="flex flex-col gap-6 md:w-1/3">
          <img src={navLogo} alt="Ubimed Logo" className="h-16 w-16" />
          <p
            style={{ color: colors.grey }}
            className="font-lato text-base font-normal leading-snug"
          >
            Ubimed Medical Consultation app aims to act as a bridge between the
            patient and possible health solutions.
          </p>
          <div className="flex gap-4">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={instagram} alt="Instagram" className="h-6 w-6" />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={linkedin} alt="LinkedIn" className="h-6 w-6" />
            </a>
            <a href="mailto:lords@lordsforerunner.net">
              <img src={email} alt="Email" className="h-6 w-6" />
            </a>
            <a
              href="https://wa.me/+234 9048220660"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={whatsapp} alt="WhatsApp" className="h-6 w-6" />
            </a>
          </div>
        </div>

        {/* Links Sections */}
        <div className="flex flex-col gap-10 md:flex-row md:gap-20">
          {/* Quick Links */}
          <div className="flex flex-col gap-4">
            <h4 className="text-white font-lato text-base font-bold tracking-wider whitespace-nowrap">
              Quick links
            </h4>
            {[
              { label: "Home", to: "/" },
              { label: "About us", to: "/about" },
              { label: "Services", to: "" },
              { label: "Contact Us", to: "/help" },
            ].map(({ label, to }) => (
              <Link
                key={label}
                to={to}
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                style={{ color: colors.grey }}
                className="font-lato text-base font-normal tracking-wider whitespace-nowrap hover:underline"
              >
                {label}
              </Link>
            ))}
          </div>

          {/* Health Specialization */}
          <div className="flex flex-col gap-4">
            <h4 className="text-white font-lato text-base font-bold tracking-wider whitespace-nowrap">
              Health Specialization
            </h4>
            {["Gynaecology", "Pediatrics", "Neurology", "Urology, etc"].map(
              (item) => (
                <span
                  key={item}
                  style={{ color: colors.grey }}
                  className="font-lato text-base font-normal tracking-wider"
                >
                  {item}
                </span>
              )
            )}
          </div>

          {/* Legal */}
          <div className="flex flex-col gap-4">
            <h4 className="text-white font-lato text-base font-bold tracking-wider whitespace-nowrap">
              Legal
            </h4>
            {[
              { label: "Privacy Policy", to: "" },
              { label: "Terms of use", to: "" },
            ].map(({ label, to }) => (
              <Link
                key={label}
                to={to}
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                style={{ color: colors.grey }}
                className="font-lato text-base font-normal tracking-wider whitespace-nowrap hover:underline"
              >
                {label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="flex justify-center">
        <img
          src={lineFooter}
          alt="Footer Divider"
          className="w-full max-w-[900px]"
        />
      </div>

      {/* Bottom Text */}
      <div
        style={{ color: colors.grey }}
        className="text-center px-4 pt-6 pb-8 font-lato text-sm md:text-base font-bold tracking-wide"
      >
        &copy; {new Date().getFullYear()} Ubimed. All Rights Reserved.
      </div>
    </footer>
  );
};

export default AboutFooter;
